import React from "react";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import { DEFAULT_INPUT_LENGTH } from "../../shared/constants/OtpValidation";
import { useOtpValidation } from "./state/useOtpValidation";
import { OtpInput } from "./OtpInput/OtpInput";
import { Translate as T } from "react-localize-redux";
import { getTextByCountry } from "../../shared/constants/TextOtpCountryEnum";
import { CountryEnum } from "../../shared/constants/CountryEnum";
var useStyle = makeStyles({
    gridButton: {
        width: "100%",
    },
    gridContainer: {
        marginBottom: "24px",
        marginTop: "50px",
    },
    input: {
        borderRadius: "4px",
        color: "#6D7781",
        fontSize: "1.1em",
        margin: "0 0.5em",
        padding: "0.8em 1em",
        textAlign: "center",
        width: "100%",
    },
});
export var OtpValidation = function (_a) {
    var _b = _a.inputLength, inputLength = _b === void 0 ? DEFAULT_INPUT_LENGTH : _b;
    var classes = useStyle();
    var state = useOtpValidation();
    return (React.createElement(Grid, { container: true, direction: "column", justify: "center", alignItems: "center", spacing: 4, className: classes.gridContainer },
        React.createElement(Grid, { item: true, xs: 11 },
            React.createElement(Typography, { color: "primary", align: "center", variant: "h5" },
                React.createElement(T, { id: "otpTextVerification.verification" }))),
        React.createElement(Grid, { item: true, xs: 11, md: 12 },
            React.createElement(Typography, { variant: "body1" },
                React.createElement(T, { id: "otpTextVerification.partOneText" }),
                React.createElement("span", null, getTextByCountry(CountryEnum.EC)),
                React.createElement(T, { id: "otpTextVerification.partTwoText" }))),
        React.createElement(Grid, { item: true, xs: 11, md: 7 },
            React.createElement(OtpInput, { autoFocus: true, isNumberInput: true, length: inputLength, onChangeOTP: state.handleOtpChange, isInvalid: state.isInvalidSecureOtp, disabled: false, inputClassName: classes.input })),
        React.createElement(Grid, { item: true, xs: 11, md: 12, className: classes.gridButton },
            React.createElement(Button, { variant: "contained", size: "large", color: "primary", fullWidth: true, disabled: state.userOtp.length < inputLength, onClick: state.handleOtpCheck },
                React.createElement(T, { id: "otpTextVerification.confirmCode" })))));
};
export default OtpValidation;
